import { ReactNode } from 'react'
import clsx from 'clsx'
import { Text, Icon } from 'components/common'
import { colors } from 'lib/colors'

export interface CheckedStatusIconProps {
  color?: string
  status: 'BeforeCheck' | 'CheckedIn' | 'CheckedOut'
  children?: ReactNode
}

export const CheckedStatusIcon = ({
  color,
  status,
}: CheckedStatusIconProps): JSX.Element => {
  let title: JSX.Element = null
  let icon: JSX.Element = null
  if (status === 'BeforeCheck') {
    title = (
      <Text strong style={{ fontSize: '16px' }}>
        チェックイン前
      </Text>
    )
    icon = (
      <Icon.InfoCircleTwoTone
        twoToneColor={color ? color : colors.KUCHINASHI}
        style={{ fontSize: '16px' }}
      />
    )
  }
  if (status === 'CheckedIn') {
    title = (
      <Text strong style={{ fontSize: '16px' }}>
        チェックイン済
      </Text>
    )
    icon = (
      <Icon.CheckCircleTwoTone
        twoToneColor={color ? color : colors.MIZUASAGI}
        style={{ fontSize: '16px' }}
      />
    )
  }
  if (status === 'CheckedOut') {
    title = (
      <Text strong style={{ fontSize: '16px' }}>
        チェックアウト済
      </Text>
    )
    icon = (
      <Icon.CheckCircleTwoTone
        twoToneColor={color ? color : colors.NAE}
        style={{ fontSize: '16px' }}
      />
    )
  }
  return (
    <>
      <div className={clsx('flex', 'flex-initial', 'items-center')}>{icon}</div>
      <div className={clsx('flex-auto', 'ml-3')}>{title}</div>
    </>
  )
}
